module.exports = __webpack_public_path__ + "img/adblue1.98e39f1e.jpg";